module.exports = __webpack_public_path__ + "img/g0227.f21fc36c.png";